"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_IMG_SIZE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const events_1 = require("../../../../constants/events");
const requestProfilesQuery_1 = require("../../../../queries/requestProfilesQuery");
const zustandStore_1 = require("../../../../zustandStore");
const message_1 = __importDefault(require("./message"));
const timestamp_1 = __importDefault(require("./timestamp"));
const userAvatar_1 = __importDefault(require("./userAvatar"));
exports.DEFAULT_IMG_SIZE = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 27 : 22;
const StyledStack = (0, material_1.styled)(material_1.Card)(ownerState => {
    const { 'ts-variant': tsVariant } = ownerState;
    return {
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        overflow: 'visible',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        marginTop: 0,
        ...(tsVariant === 'isUserAuthor' ? { alignSelf: 'flex-end' } : { alignSelf: 'flex-start' }),
    };
});
const hardCodedStyles = { fontSize: '12px', fontWeight: 'normal' };
const StyledCard = (0, material_1.styled)(material_1.Card)(ownerState => {
    const { 'ts-variant': tsVariant, theme } = ownerState;
    return {
        fontWeight: theme.typography.tsFontWeight.bold,
        fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
        color: `${theme.palette.common.black} !important`,
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        position: 'relative',
        overflow: 'initial',
        width: 'fit-content',
        ...(tsVariant === 'isUserAuthor' ? { alignSelf: 'flex-end' } : {}),
    };
});
const StyledCardContent = (0, material_1.styled)(material_1.CardContent)(({ theme }) => ({
    padding: theme.tsGoUnit.tsUnitHalf,
    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
        ? {
            padding: '0 10px',
        }
        : {}),
    '&:last-child': {
        paddingBottom: `calc(${theme.tsGoUnit.tsUnitHalf} - 1px)`,
        ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
            ? {
                paddingBottom: 0,
            }
            : {}),
    },
}));
const SpeechBubble = ({ event, isUserAuthor }) => {
    const { setRequestFields, setPurchaseRequest, setPageLoading } = (0, zustandStore_1.useZustand)();
    const companyId = (0, zustandStore_1.useZustand)(state => state.company.companyId);
    const purchaseRequest = (0, zustandStore_1.useZustand)(state => state.request.purchaseRequest);
    const { data: formFields } = (0, react_query_1.useQuery)((0, requestProfilesQuery_1.requestProfilesQuery)(companyId, event.type === events_1.events.types.purchases.requestCreated));
    (0, react_1.useEffect)(() => {
        if (formFields?.fieldDefinitions && formFields?.id) {
            setRequestFields(formFields?.fieldDefinitions);
            if (purchaseRequest?.profileId === formFields?.id) {
                return;
            }
            const purchaseReq = (purchaseRequest) => ({
                ...purchaseRequest,
                profileId: formFields?.id,
            });
            setPurchaseRequest(purchaseReq);
        }
    }, [formFields, purchaseRequest?.state]);
    (0, react_1.useEffect)(() => {
        setPageLoading(false);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(StyledStack, { "ts-variant": isUserAuthor ? 'isUserAuthor' : undefined, style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? {
                    paddingTop: '40px',
                    paddingBottom: 0,
                }
                : {}),
        }, children: [(0, jsx_runtime_1.jsxs)(StyledCard, { "ts-variant": isUserAuthor ? 'isUserAuthor' : undefined, children: [(0, jsx_runtime_1.jsx)(userAvatar_1.default, { style: hardCodedStyles, isCurrentUserAuthor: isUserAuthor, event: event }), (0, jsx_runtime_1.jsx)(StyledCardContent, { style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    border: '1px solid #979797',
                                    minWidth: 'auto',
                                }
                                : {}),
                        }, children: (0, jsx_runtime_1.jsx)(message_1.default, { event: event }) })] }), (0, jsx_runtime_1.jsx)(timestamp_1.default, { event: event, isCurrentUserAuthor: isUserAuthor })] }));
};
exports.default = (0, react_1.memo)(SpeechBubble);
